import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = { class: "col-md-9 col-sm-12" }
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = { class: "mt-5 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HacktivityWidget = _resolveComponent("HacktivityWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feeds, (feed, index) => {
          return (_openBlock(), _createBlock(_component_HacktivityWidget, {
            id: index,
            key: feed,
            feed: feed,
            user: feed.user,
            currentUser: _ctx.user,
            widgetClasses: 'mt-5'
          }, null, 8, ["id", "feed", "user", "currentUser"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}